// import * as validation from '../../../../common/utils/validation';

const allowedPhoneChars = '+ 1234567890';

export default (values) => {
  const errors = {};

  if (!values?.first_name) errors.first_name = true;
  if (!values?.last_name) errors.last_name = true;
  const invalidPhone = values?.phone_num?.split('').find((char) => {
    return allowedPhoneChars.indexOf(char) < 0;
  });
  if (
    // values?.phone_num &&
    // TODO valid phone numbers are rejected by this logic, phone validation
    // should be refactored in the whole app
    // !validation.test('PHONE_NUM', values.phone_num)
    invalidPhone
  ) {
    errors.phone_num = true;
  }

  return errors;
};
